import React, { useEffect, useContext, useState } from 'react'
import { useQuery, useApolloClient } from '@apollo/client';
import { GlobalContext } from '../../hooks/globalContext';

// import { getStatusListsCntQuery,getStatusListsQuery } from '../graphql/status_queries';
// import { getInstallStatus,getCensusList,getInstallStatusCnt,getEdconfigQuery, setExecuteTroubleShooter} from '../graphql/app_install_status_queries';
import { getInstallStatus, getCensusList, getInstallStatusCnt, getswdForm, getJsonSchemaQueryPackageDetails, getJsonSchemaQueryAdvanceConfiguration, getJsonSchemaQueryAppConfiguration, getEdconfigQuery, deployPackageJob, getStatus } from '../../graphql/app_install_status_queries';
import { matchPath } from 'react-router-dom';
import AppConfig from '../../utility/AppConfig';
import apiCall from '../../utility/api';


type dataProps = {
    data?: any;
    func?: any;
    func1?: any;
    searchVal: any
    pageNo: any
    setTotalPages: any
    setTotalRecords: any
    savePackageDetails?: any; // Making it optional
    setSavePackageDetails?: any
    isFilter?: any
    dropDownValue1?: any
    setIsFilter?: any
    dropDownValue2?: any
    isRefresh?: any,
    setIsRefresh?: any
    setRefreshToast?: any
    deployPackageDetails?: any
    setDeployPackageDetails?: any
    setRowId?: any
    rowId?: any
    handleEditData?: any
    setJsonDataPkg?: any
    setUiDataPkg?: any
    setJsonDataApp: any
    setUiDataApp: any
    setJsonDataAdv: any
    setUiDataAdv: any
    rowDesc?: any
    type?: any
    filterArray?: any
    pushClassification?: any
    setPushClassification?: any
    pushClassificationType?: any
    setPushClassificationType?: any
    setPreviousJob?: any
    setJobPush?: any
    setJobFailed?: any
    setExportDetails?: any;
    exportBtnClicked?: any;
    setExportBtnClicked?: any;
	tenant?: any
    setOverlayOpen?: any 
    pendingJob?: any
    setPending?: any
    setPendingJob?: any
    setpendingJobMessage?: any
    setSpinnerLoad?: any
}

export const Install_Status_func = (props: dataProps) => {
    const client = useApolloClient();
    const contextValue: any = useContext(GlobalContext);
    const [edconfig, setEdconfig] = useState(null);
    var tenantName = contextValue.tenantName;
    const getSwdList = async (whereCondition: any, limit: Number, offset: Number) => {
        try {
            let { data, status } = await apiCall('/softDist/getSwd', { ...whereCondition, limit, offset });
            if (status === 'success') {
                props.func(data);
                // getStatusList(null); // todo: replace this after communication audit fixed.
            }
        } catch (error) {
            console.log('getSWdList error=', error);
        }
    };
    const getSwdListCnt = async (whereCondition: any) => {
        try {
            const { status, data } = await apiCall('/softDist/getSwdCount', { ...whereCondition });

            if (status === 'success') {
                props?.setTotalRecords(data.totalRecords);
                props?.setTotalPages(data.totalPages);
            } else {
                console.log("No records found or unsuccessful status.");
            }
        } catch (error) {
            console.log('getSwdListCnt error:', error);
        }
    };


    const deploy_exec = async (machineName: any, packageIdPush: any, packageDescPush: any) => {
        var url = `${AppConfig.DASHBOARD_V2_API_URL}/troubleshoot/pushSolutionItems`;
        var postData = {
            "servicetag": machineName,
            "solutionVar": packageDescPush,
            "username": contextValue.userSessionDetails.userEmail,
            "type": "Software Distribution",
            "pushClassification": props.pushClassification,
            "pushClassificationType": props.pushClassificationType,
            "id": props.rowId,
            "email": contextValue.userSessionDetails.userEmail,
            "applicationname": `SWD : ${packageDescPush}`
        };
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        await fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(postData),
            redirect: "follow"
        }).then((response) => response.text())
            .then((result: any) => {
                result = JSON.parse(result);
                if (result.status == "success") {
                    props.setJobPush(true);
                } else {
                    props.setJobFailed(true)
                    console.log('error: ',result)
                }
            }).catch((error) => console.error(error));
    }

    const getForm = async () => {
        const app_packageId = props.rowId;
        try {
            const data = await apiCall('/softDist/getPackagesFormData', { app_packageId });
            if (data.status === "success") {
                props.handleEditData(data);
                props.setSpinnerLoad(false);
            }
        } catch (error) {
            console.error("An unexpected error occurred:", (error as Error).message);
        }
    };

    const getJsonSchemaQueryPkg = async () => {
        const dartid = 1501
        const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });

        if (status === 'success' && data.length > 0) {
            var uiSchema = JSON.parse(data?.[0]?.uiSchema);
            uiSchema["ui:submitButtonOptions"] = {
                "norender": true,
            };
            var jsondata = JSON.parse(data?.[0]?.jsonSchema);
            (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataPkg(jsondata);
            data?.[0]?.uiSchema != undefined && props.setUiDataPkg(uiSchema);
        }
    };

    const getJsonSchemaQueryApp = async () => {
        if (props.type !== 'Uninstallation') {
            const dartid = props.type == 'Uninstallation' ? 1504 : 1502;
            const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });

            if (status === 'success' && data.length > 0) {
                var uiSchema = JSON.parse(data[0]?.uiSchema);
                uiSchema["ui:submitButtonOptions"] = {
                    "norender": true,
                };

                // get the list of files from s3 and set dropdown
                const headers = {
                    'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOnRydWUsImlhdCI6MTcwOTEwMzk0NCwiZXhwIjoxNzA5MTA3NTQ0fQ.TrZ0b_SQ5kVQOkTItuuzz4HAZe7QpSZtTzmbw9IB0V8',
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                };
                const requestOptions = {
                    method: 'GET', // specify the HTTP method (GET, POST, etc.)
                    headers: headers,
                };

                try {
                    const fileData = await apiCall('/softDist/getFiles')
                    var list = fileData.data.map((val: any) => val.Key)
                    // setFilesList(list)
                } catch (error: any) { console.error('Error fetching files:', error) };

                var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
                if (jsonSchemaData?.items?.allOf[0]?.dependencies?.Application_details?.oneOf[1]?.properties?.uploadApplication1) {
                }
                (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
                data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
            }
        } else {
            const dartid = props.type == 'Uninstallation' ? 1504 : 1502;
            const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });

            if (status === 'success' && data.length > 0) {
                var uiSchema = JSON.parse(data[0]?.uiSchema);
                uiSchema["ui:submitButtonOptions"] = {
                    "norender": true,
                };
                var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
                (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
                data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
            }
        }
    };

    const getJsonSchemaQueryAdv = async () => {
        const dartid = 1503;
        const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });

        if (status === "success" && data.length > 0) {
            var uiSchema = JSON.parse(data?.[0]?.uiSchema);
            uiSchema["ui:submitButtonOptions"] = {
                "norender": true,
            };
            var jsonSchemaData = JSON.parse(data?.[0]?.jsonSchema);
            (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataAdv(jsonSchemaData);
            data?.[0]?.uiSchema != undefined && props.setUiDataAdv(uiSchema);
        }
    };

    const checkPendingJobs = async () => {
        const machineList: any = contextValue.selectedRowIdInTable;
        let applicationName = props.rowDesc;
        try {
            let whereCondition = { applicationName, machineList }
            let { status, data } = await apiCall('/softDist/getPendingJobStatus', { ...whereCondition });
            return data
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    const deployPackage = () => {

        const packageIdPush: any = props?.rowId;
        const packageDescPush: any = props?.rowDesc;
        // getEdconfig()
        let machineList: any = contextValue.selectedRowIdInTable
        checkPendingJobs().
            then((data) => {
                if (data?.length > 0) {
                    props.setDeployPackageDetails(false);
                    props.setPreviousJob(true)
                    return;
                } else {
                    machineList.map((machineName: any) => {
                        deploy_exec(machineName, packageIdPush, packageDescPush)
                    })
                    props.setOverlayOpen(false);
                }
            })
            .catch((error) => {
                console.error("Error occurred:", error);
            });

        // machineList.map((machineName: any) => {
        //     deploy_exec(machineName, packageIdPush, packageDescPush)
        // })
    }

    const getExportData = async (condition: object, setExportDetails: any) => {
		try {
			const { status, data } = await apiCall('/softDist/getSwd', condition); 

			if (status === 'success' && data.length > 0) {
                props.exportBtnClicked && props.setExportDetails !== undefined && props.setExportDetails(data);
			} else {
				setExportDetails([]);
			}
		} catch (error) {
			console.log("remediation getExportData error=", error);
			setExportDetails([]);
		}
        props.setExportBtnClicked(false);
	}

    const clearPendingJobs = async () => {
        const machineList: any = contextValue.selectedRowIdInTable
        let applicationName = props.rowDesc;
        try {
            let whereCondition = { applicationName, machineList }
            let { status, data } = await apiCall('/softDist/deletePendingJobs', { ...whereCondition });
                console.log("data=", data);
                if (data.affected_rows > 0 && status === "success") {
                    console.log("Pending Job Cleared");
                    props.setpendingJobMessage(true)
                    // alert("Pending Job Cleared")
                } else if (data.affected_rows === 0 && status === "failure") {
                    console.log("No Pending Job to clear");
                    props.setpendingJobMessage(true)
                    // alert("Pending Job Cleared")
                } else {
                    console.log("Pending Job Not Cleared");
                }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }
    useEffect(() => {
        // getList();
        if (props.deployPackageDetails == true) {
            deployPackage()
            props.setDeployPackageDetails(false) && contextValue.setSelectedRowIdInTable([]);
        }
        if (props.pendingJob == true) {
            clearPendingJobs()
            props.setpendingJobMessage(false)
            props.setPendingJob(false)
        }
        if (props.searchVal.length > 0 && props.searchVal !== '') {
            // getSwdList({ packageName: { contains: props.searchVal }, status: { _eq: props.type }, type:"search" }, 50, parseInt(props.pageNo))
            // getSwdListCnt({ packageName: { contains: props.searchVal }, status: { _eq: props.type }, type:"search" });
            getSwdList({ status: props.type, search: props.searchVal, type: 'search' }, 50, parseInt(props.pageNo))
            getSwdListCnt({ status: props.type, search: props.searchVal, type: 'search' });
        } else if (props.isFilter == true) {
            getSwdList({ filter: props.filterArray, status: props.type, type: 'filter' }, 50, props.pageNo);
            getSwdListCnt({ filter: props.filterArray, status: props.type, type: 'filter' });
        } else {
            getSwdList({ status: props.type, }, 50, parseInt(props.pageNo));
            getSwdListCnt({ status: props.type, });
            getJsonSchemaQueryPkg();
            getJsonSchemaQueryApp();
            getJsonSchemaQueryAdv();
        }
    }, [props.searchVal, props.pageNo, props.deployPackageDetails, props.isFilter, props.filterArray, props.pendingJob]);
    useEffect(() => {
        if (props.rowId) {
            getForm();
        }
    }, [props.rowId])

    useEffect(() => {  
        if (props.isRefresh) {
            getSwdList({ status: props.type, }, 50, parseInt(props.pageNo));
            getSwdListCnt({ status: props.type,});
        }
        if (props.exportBtnClicked) {
                // Trigger both export data API calls
                const fetchExportData = async () => {
                    try {
                        // First API call for export details
                        const exportResponse = await apiCall('/softDist/getSwd', {
                            function: 'export', 
                            tenant: props.tenant, 
                            status: props.type 
                        });
                        
                        // Extract IDs from exportResponse.data
                        // const app_packageId = exportResponse.data.map(item => item.id);
    
                        // Second API call for configuration details
                        // const configResponse = await apiCall('/softDist/getPackagesFormData', {app_packageId});
        
                        // Check if both calls were successful
                        // if (exportResponse.status === 'success' && configResponse.status === 'success') {
                            // Set the export details
                            props.setExportDetails(exportResponse.data || []);
                            // props.setExportConfigDetails(configResponse.data || []);
                        // } else {
                        //     // Handle error scenario
                        //     console.error('Export data fetch failed');
                        // }
                    } catch (error) {
                        console.error('Export data fetch error:', error);
                    } finally {
                        // Reset export button state
                        props.setExportBtnClicked(false);
                    }
                };
                // Call the async function
                fetchExportData();
        }
    }, [props.exportBtnClicked, props.isRefresh])

    return (
        <>
        </>
    )
}